import React, {Fragment, useState} from 'react';
import AppInitializer from "./AppInitializer";
import LoadingSpinner from "../library/loaders/LoadingSpinner";
import ApiErrorModalInitializer from "./initializers/ApiErrorModalInitializer";
import useAuthProvider from "../../hooks/useAuthProviderHook";

const AddLoadConfiguration = (ComponentWithConfiguration) => {
  const AuthGatedComponent = (props) => {
      const isAuthReady = useAuthProvider();

      if (!isAuthReady) return <LoadingSpinner />;

      return <ComponentWithConfiguration {...props} />;
  };

  const WrappedComponent = (props) => {
    const [loaded, setLoaded] = useState(false);
        if (loaded) {
            return (
                <Fragment>
                    {/* We always need the api error modal initializer to exist */}
                    <ApiErrorModalInitializer />
                      <AuthGatedComponent {...props} />
                </Fragment>
            );
        }

        return (
            <div>
                <LoadingSpinner />
                <AppInitializer {...props} onLoaded={() => setLoaded(true)} />
            </div>
        );
    };

    return WrappedComponent;
}
export default AddLoadConfiguration;
